// Main exports
export { WorkspaceFileSystem } from "./WorkspaceFileSystem";
export { WorkspaceDatabase } from "./WorkspaceDatabase";

// Types
export * from "./types";

// Provider interfaces
export type { 
  SourceProvider,
  PersistableSourceProvider,
  ConvertibleSourceProvider,
  ProviderRegistry
} from "./interfaces/SourceProvider";

// Import/Export
export * from "./import-export";

// Credential Management
export { 
  CredentialManager, 
  BrowserCredentialProvider, 
  EnvCredentialProvider,
  InteractiveCredentialProvider
} from "./credentials/CredentialManager";
export { SourceConfigBuilder } from "./credentials/SourceConfigBuilder";

// Source loaders removed - now using provider pattern

// Re-export core types for convenience
export type {
  IFileSystem,
  IReactiveFileSystem,
  FileEntry,
  FileStat,
  FileMetadata,
  FSEvent,
  Disposable,
  FileSystemEventPayloads,
} from "@firesystem/core";

// Re-export values
export { FileSystemEvents } from "@firesystem/core";

// Test suite for providers - removed from main export to avoid vitest dependency
